"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RESIDUAL_TYPE = exports.RESIDUAL_DOLLAR = exports.RESIDUAL_PERCENT = exports.OFFER_TYPE = exports.DEALER = exports.SHOPPER = exports.CASH = exports.LOAN = exports.LEASE = exports.FINANCE = void 0;
exports.FINANCE = 'finance';
exports.LEASE = 'lease';
exports.LOAN = 'loan'; // loan is just an "alias" for finance (but only used by Credit App)
exports.CASH = 'cash';
exports.SHOPPER = 'shopper';
exports.DEALER = 'dealer';
exports.OFFER_TYPE = {
    finance: exports.FINANCE,
    lease: exports.LEASE,
    loan: exports.LOAN,
    cash: exports.CASH
};
exports.RESIDUAL_PERCENT = 'percent';
exports.RESIDUAL_DOLLAR = 'dollar';
exports.RESIDUAL_TYPE = {
    dollar: exports.RESIDUAL_DOLLAR,
    percent: exports.RESIDUAL_PERCENT
};
